import classNames from 'classnames';
import { Severity } from 'Data/ViewModels/Core/types';
import React from 'react';
import coalesce from '../../../Lib/coalesce';
import { withInjectedProps } from '../InjectedPropsContext';

export type IEmailInputProps = Pick<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  'autoFocus' | 'defaultValue' | 'disabled' | 'id' | 'maxLength' | 'name' | 'onChange' | 'onKeyDown' | 'placeholder'
> & {
  focusRef?: React.Ref<HTMLInputElement>;
  severity?: Severity;
  value?: any;
};

const EmailInputBase: React.FC<IEmailInputProps> = ({
  autoFocus,
  defaultValue,
  disabled,
  id,
  focusRef,
  maxLength,
  name,
  onChange = () => {},
  onKeyDown = () => {},
  placeholder = 'Enter valid email address',
  severity,
  value,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    (event as any).data = { name, value: event.target.value, submitValues: false };
    onChange(event);
  };
  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    (event as any).data = { name, value: event.target.value, submitValues: true };
    onChange(event);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && !event.defaultPrevented) {
      (event as any).data = { name, value: (event.target as HTMLInputElement).value, submitValues: true };
      onChange(event as any);
    }
    onKeyDown(event);
  };

  const cx = classNames('EmailInput', { [`Input-${severity}`]: !!severity });

  return (
    <input
      autoFocus={autoFocus}
      className={cx}
      defaultValue={defaultValue === undefined ? defaultValue : coalesce(defaultValue, '')}
      disabled={disabled}
      id={id}
      maxLength={maxLength}
      name={name}
      onBlur={handleBlur}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      ref={focusRef}
      type="email"
      value={value === undefined ? value : coalesce(value, '')}
    />
  );
};

const EmailInput = withInjectedProps(EmailInputBase);

export { EmailInput, EmailInputBase };
export default EmailInput;
